import { Flex, Text } from "@radix-ui/themes";
import storeBadgeApple from "../../assets/store-badge-apple.svg";
import storeBadgeGoogle from "../../assets/store-badge-google.svg";
import { APPLE_APP_STORE_LINK, GOOGLE_PLAY_STORE_LINK } from "../app-links";
import { isWebAndroidPlatform, isWebIOSPlatform } from "../utils/environment";

type AppStoreButtonsProps = {
  showDescription?: boolean;
};

export const AppStoreButtons: React.FC<AppStoreButtonsProps> = ({
  showDescription = true,
}) => {
  const detectedIOS = isWebIOSPlatform();
  const detectedAndroid = isWebAndroidPlatform();
  const showBothStores = !detectedIOS && !detectedAndroid;

  return (
    <Flex direction="column" gap="4" align="center" style={{ width: "100%" }}>
      {showDescription && (
        <Text>
          <strong>Falls Sie die App noch nicht installiert haben</strong>, laden
          Sie sie hier herunter:
        </Text>
      )}
      <Flex gap="3" justify="center" style={{ alignSelf: "center" }}>
        {(detectedIOS || showBothStores) && (
          <a
            href={APPLE_APP_STORE_LINK}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={storeBadgeApple}
              alt="Download on the App Store"
              style={{ height: "40px" }}
            />
          </a>
        )}
        {(detectedAndroid || showBothStores) && (
          <a
            href={GOOGLE_PLAY_STORE_LINK}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={storeBadgeGoogle}
              alt="Get it on Google Play"
              style={{ height: "40px" }}
            />
          </a>
        )}
      </Flex>
    </Flex>
  );
};
